import { KibChipChoice } from '@chewy/kib-chips-react'
import { KibAttachIcon } from '@chewy/kib-icons-react'
import classNames from 'classnames'

import type { IdentifiedAttachmentOrigin } from '~/types'

import { useChatContainer } from '../context/ChatContainerContext'

import '@chewy/kib-chips-styles/dist/styles/kib-chip-choice.css'
import styles from './MessageAttachment.module.scss'

const MessageAttachment = ({
  attachment,
  choiceGroupName,
  hidden,
}: {
  attachment: IdentifiedAttachmentOrigin
  choiceGroupName: string
  hidden: boolean
}) => {
  const { id, name } = attachment
  const { selectedAttachment, setSelectedAttachment } = useChatContainer()
  const selectedValue = selectedAttachment?.id
  const isSelected = selectedValue === id

  return (
    <KibChipChoice
      className={classNames(styles.attachmentChip, {
        [styles.selected]: isSelected,
        [styles.unselected]: !isSelected,
        [styles.hidden]: hidden,
      })}
      icon={<KibAttachIcon />}
      id={id}
      name={choiceGroupName}
      selectedValue={selectedValue}
      value={id}
      onChange={() => setSelectedAttachment(attachment)}
    >
      {name}
    </KibChipChoice>
  )
}

export default MessageAttachment
